import { Loader } from 'lucide-react'

import { Button } from '../button'

interface Props {
    className?: string
    isLoading: boolean
    fetchNextPage: () => void
    hasNextPage: boolean
}

export default function LoadMoreButton({ isLoading, fetchNextPage, hasNextPage, className }: Props) {
    if (!hasNextPage) {
        return null
    }

    return (
        <Button variant="link" onClick={() => fetchNextPage()} disabled={isLoading} className={className}>
            {isLoading && <Loader className="w-4 h-4 mr-2 animate-spin" />}
            Load more
        </Button>
    )
}
